export const labelSanitizePattern = /[^\p{L}\p{N}_ -]/gu;
export const spacesPattern = /\s+/g;

/**
 * Sanitizes a label by removing unsupported characters and normalizing spaces.
 *
 * @param {string | undefined | null} label - The label to sanitize.
 * @returns {string} The sanitized label.
 *
 * @example
 * const label = 'My Label 123';
 * const sanitizedLabel = sanitizeLabel(label); // 'my label 123'
 */
export const sanitizeLabel = (label = '') => {
  if (!label) return '';

  return label
    .trim()
    .toLowerCase()
    .replace(spacesPattern, ' ')
    .replace(labelSanitizePattern, '');
};
